import { render, staticRenderFns } from "./OnboardingWeight.vue?vue&type=template&id=3c239be0&scoped=true&"
import script from "./OnboardingWeight.vue?vue&type=script&lang=js&"
export * from "./OnboardingWeight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c239be0",
  null
  
)

export default component.exports